<template>
  <div v-if="show" class="custom-overlay" @click.self="close">
    <div class="custom-modal">

      <!-- Header -->
      <div class="modal-header">
        <h3>{{ title }}</h3>
        <button class="close-btn" @click="close">×</button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <slot></slot>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn-cancel" @click="close">
          {{ cancelText }}
        </button>
        <button class="btn-confirm" @click="confirm">
          {{ confirmText }}
        </button>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomPrompt",
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: "Confirmation" },
    confirmText: { type: String, default: "OK" },
    cancelText: { type: String, default: "Cancel" }
  },
  methods: {
    close() {
      this.$emit("update:show", false);
      this.$emit('cancel')
    },
    confirm() {
      // this.$emit("update:show", false);
      this.$emit('confirm')
    }
  }
};
</script>

<style scoped>
.vue-datepicker {
  position: relative !important;
}

.vue-datepicker .dropdown,
.vue-datepicker .datepicker,
.vue-datepicker .vuejs-datepicker {
  z-index: 99999 !important;
}

.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 80px;
  z-index: 50000;
}

.custom-modal {
  width: 480px;
  /* Jarak sama dari setiap sisi */
  inset: 40px;  /* <---- ganti angka sesuai kebutuhan */

  margin: auto; /* membuat modal center */

  background: white;
  border-radius: 12px;
  /* overflow: hidden; */
    overflow: visible !important;
  box-shadow: 0 6px 20px rgba(0,0,0,0.25);
  animation: fadeInUp 0.25s ease;
}

@keyframes fadeInUp {
  from { transform: translateY(20px); opacity: 0; }
  to   { transform: translateY(0); opacity: 1; }
}

.modal-header {
  padding: 16px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #777;
}
.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 14px 20px;
  background: #fafafa;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ccc;
  background: white;
  border-radius: 6px;
  cursor: pointer;
}

.btn-confirm {
  padding: 8px 16px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.btn-confirm:hover {
  background: #d7392b;
}
</style>
